import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import './Login.css';

const Login = () => {
  const { loginWithRedirect } = useAuth0();

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <h1>Genomic Database Platform</h1>
          <p className="login-subtitle">Secure access to advanced genomic research tools</p>
        </div>
        
        <div className="login-content">
          <div className="login-icon">
            <img 
              src="/mainlogo.webp" 
              alt="Plant Genomics" 
              style={{ width: '120px', height: 'auto' }}
            />
          </div>
          
          <h2>Welcome Back</h2>
          <p className="login-description">
            Sign in to access genomic data analysis, visualization tools, and AI-powered insights.
          </p>
          
          <button 
            className="login-button"
            onClick={() => loginWithRedirect()}
          >
            Sign In
          </button>
          
          <div className="login-features">
            <div className="feature-item">
              <span className="feature-icon">📊</span>
              <span>Data Analytics</span>
            </div>
            <div className="feature-item">
              <span className="feature-icon">🧬</span>
              <span>Data Explorer</span>
            </div>
            <div className="feature-item">
              <span className="feature-icon">🤖</span>
              <span>AI Assistant</span>
            </div>
          </div>
        </div>
        
        <div className="login-footer">
          <p>© Kovi MR — Graminor</p>
        </div>
      </div>
    </div>
  );
};

export default Login;
